import {Modal, notification, Table} from "antd";
import React, {useContext, useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {IoCreateOutline} from "react-icons/io5";
import {MdContentCopy} from "react-icons/md";
import {useNavigate} from "react-router-dom";
import {ButtonWithIcon} from "../../../components/AntCostomComponents/Buttons";
import {UserContext} from "../../../context/UserContext";
import {getSurveysByPatientId, getSurveyToken} from "../../../utils/api-lists/patient.api";
import {formatDate} from "../../../utils/date.util";
import {copyUrlToClipboard} from "../../../utils/general.util";

const LifeStyleModal = ({isVisible, onClose, patientId}) => {
    const [surveys, setSurveys] = useState(null);
    const {user} = useContext(UserContext);

    const {t} = useTranslation("common");
    const navigate = useNavigate();

    useEffect(() => {
        const fetchSurveys = async () => {
            try {
                const data = await getSurveysByPatientId(patientId);
                setSurveys(data);
            } catch (error) {
                console.error("Error fetching surveys:", error);
            }
        };

        fetchSurveys();
    }, [patientId]);


    const surveyColumns = [
        {
            title: <span className="text-gray-400">{t("no")}</span>,
            key: "index",
            render: (_, __, index) => (
                <span className="text-gray-400">{index + 1}</span>
            ),
        },
        {
            title: <span className="text-gray-400">{t("date")}</span>,
            dataIndex: "timestamp",
            key: "date",
            render: (date) => (
                <span className="text-gray-300 text-sm">
                    {formatDate(new Date(date), "MM-dd-yyyy HH:mma")}
                </span>
            ),
        },
    ];

    const dataSource = surveys?.map((survey, index) => ({
        key: survey.id,
        timestamp: survey.timestamp,
        index,
    }));

    return (
        <Modal
            title={t("lifeStyle")}
            open={isVisible}
            className="custom-dark-modal"
            onCancel={onClose}
            footer={null}
            width={700}
        >
            <Table
                columns={surveyColumns}
                dataSource={dataSource}
                pagination={false}
                className="custom-ant-table"
                rowClassName={() => "border-b border-gray-700"}
                onRow={(record) => ({
                    onClick: () => {
                        navigate(`patient-survey/${record.key}`);
                    },
                    style: {
                        cursor: "pointer",
                    },
                })}
                locale={{
                    emptyText: (
                        <div className="text-gray-400 text-sm py-6 text-center">
                            {t("no_surveys")}
                        </div>
                    ),
                }}
            />
            <div className="mt-4 flex justify-end gap-2">
                <ButtonWithIcon
                    text={t("new_lifeStyle_survey")}
                    icon={IoCreateOutline}
                    onClick={() => {
                        navigate(`/patient-cabinet/${patientId}/patient-create-survey`);
                    }}
                />
            </div>
        </Modal>
    );
};

export default LifeStyleModal;
